/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine200,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine500,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLinePathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLineQueryResponse,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine.ts";
import { digitableLineResponseViewModelSchema } from "../digitableLineResponseViewModelSchema.ts";

export const getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLinePathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLinePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine200Schema =
  z.lazy(
    () => digitableLineResponseViewModelSchema,
  ) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine401Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine404Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine500Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine500>;

export const getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLineQueryResponseSchema =
  z.lazy(
    () => getApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLine200Schema,
  ) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidDigitableLineQueryResponse>;
